import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { rem } from 'polished'
import { PICKER_DATE_FORMAT } from 'constants/dateFormats'
import TextButton from 'components/Luxkit/Button/TextButton'
import RightHeadedArrowIcon from 'components/Luxkit/Icons/custom/RightHeadedArrowIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Dropdown from 'components/Luxkit/Dropdown/Dropdown'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import Group from 'components/utils/Group'

const Footer = styled(Group)`
  padding: ${rem(24)};  
  box-shadow: ${props => props.theme.shadow.flat.small};
`

const Content = styled.div`
  padding: ${rem(20)};
`

interface Props {
  open: boolean;
  checkinDate?: moment.Moment;
  checkoutDate?: moment.Moment;
  travellerLabel?: string;
  className?: string;
  triggerRef: React.RefObject<HTMLElement>;
  hideFooter?: boolean;
  heading?: string;
  termsAndConditions?: string;
  onApply: () => void;
  onCancel: () => void;
  anchorRef?: React.RefObject<HTMLElement>;
}

function FlightSearchMenuDesktop(props: PropsWithChildren<Props>) {
  const {
    open,
    checkinDate,
    checkoutDate,
    children,
    travellerLabel,
    className,
    triggerRef,
    hideFooter,
    heading,
    termsAndConditions,
    onApply,
    onCancel,
    anchorRef,
  } = props

  return (
    <Dropdown
      open={open}
      onClose={onApply}
      className={className}
      triggerRef={triggerRef}
      anchorRef={anchorRef}
      floatingStrategy="absolute"
      disableFlip
      width="100%"
      position="bottom"
    >
      <DropdownContainer title={heading} fit="container">
        <Content>
          {children}
        </Content>
        {!hideFooter && <Footer direction="horizontal" verticalAlign="center" horizontalAlign="space-between">
          <div>
            {termsAndConditions && <BodyText variant="small" colour="neutral-two">{termsAndConditions}</BodyText>}
          </div>
          <Group direction="horizontal" gap={16} verticalAlign="center">
            {checkinDate && checkoutDate && (
              <Group direction="horizontal" gap={12} verticalAlign="center">
                <BodyText variant="medium" weight="semi-bold">{moment(checkinDate).format(PICKER_DATE_FORMAT)}</BodyText>
                <RightHeadedArrowIcon />
                <BodyText variant="medium" weight="semi-bold">{moment(checkoutDate).format(PICKER_DATE_FORMAT)}</BodyText>
              </Group>
            )}
            {travellerLabel && (
              <BodyText variant="medium" weight="semi-bold">{travellerLabel}</BodyText>
            )}
            <TextButton kind="tertiary" onClick={onCancel}>Cancel</TextButton>
            <TextButton data-testid="apply-flight-search-changes" kind="primary" type="submit" onClick={onApply}>Apply</TextButton>
          </Group>
        </Footer>}
      </DropdownContainer>
    </Dropdown>
  )
}

export default FlightSearchMenuDesktop
